import * as React from 'react';
import withAdviserState, {
	InjectedProps,
} from '../../hoc/AdviserStateConnector';
import FooterLinks from '../../presentational/Footer/FooterLinks';
import { getNavigationFooterLinks } from '../../../logic/functions/footerLinks.function';
interface Link {
	url: string;
	title: string;
	openInNewTab: boolean;
}

type Props = Pick<InjectedProps, 'lastLoggedin'>;

const FooterLinksContainer = (props: Props) => {
	const [footerLinks, setData] = React.useState(new Array<Link>());

	React.useEffect(() => {
		async function fetchData() {
			const data = await getNavigationFooterLinks();
			setData(data);
		}
		fetchData();
	}, []);

	return (
		<FooterLinks
			links={footerLinks}
			lastLoginDate={props.lastLoggedin}
			isSecure={true}
		/>
	);
};

export default withAdviserState(FooterLinksContainer);
